import labels from "emun.invoice/credit-request/_labels";
import controller from "emun.invoice/credit-request/credit-request-prompt.controller";
import templateUrl from "emun.invoice/credit-request/credit-request-prompt.htm";
import config from "servicestack/email/send-email-config";
import open from "webmodals/open";

export default (options) =>
  open({
    size: options.size || "sm",
    templateUrl: options.templateUrl || templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () =>
        Object.assign(
          {
            commandLabel: "Save",
            transitionTo: "retailer.creditRequest",
            title: `Request ${labels.abbr}: ${options.model.invoiceId}`,
          },
          options,
          config
        ),
    },
  }).result;
